import * as React from 'react';

import './List.scss';

interface ListProps {
  title?: string;
  children: JSX.Element | JSX.Element[];
}

const List = ({ title, children }: ListProps): JSX.Element => (
  <div className="list">
    {title && <h3 className="list__title">{title}</h3>}
    {children}
  </div>
);

export default List;
